import React from 'react'
import NavLink from '../../components/Routes/NavLink'

export default class CreditCardCard extends React.Component {
    render() {
        const id = this.props.id
        const fingerprint = this.props.fingerprint
        const cardName = this.props.cardName
        const isDefault = this.props.isDefault
        const lastFour = this.props.lastFour
        const issuer = this.props.issuer
        const cardStatus = this.props.cardStatus
        return(
            <div class="col-md-3 col-sm-6 col-xs-12">
                <NavLink to={"/account/billing/cc/" + id}>
                    <div class="info-box">
                        <span class="info-box-icon blue-icon-circle"><i class="icon-credit-cards-filled"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">
                                {cardName}
                                {isDefault && (
                                    <small class="green"> primary</small>
                                )}
                            </span>
                            <br />
                            <span class="info-box-subtext bank-info">
                                <small>Last Four:</small> {lastFour}
                            </span>
                            <br />
                            <span class="info-box-subtext bank-info">
                                <small>Issuer:</small> {issuer}
                            </span>
                            <br />
                            <span class="info-box-subtext bank-info">
                                <small>Status:</small>&nbsp;
                                {cardStatus.address_postal_code_check == 'fail' || cardStatus.cvc_check == 'fail' ? (
                                    <span class="red-info-number">
                                        FAILED
                                    </span>
                                ) : (
                                    <span class="green">
                                        VERIFIED
                                    </span>
                                )}
                            </span>
                        </div>
                    </div>
                </NavLink>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// app/helpers/Cards/CreditCardCard.jsx